import React from 'react';
import Marker from './Marker';

export default function Floorplan({
  activeFilters,
  activeFloorplan,
  adjustX,
  adjustY,
  className,
  height,
  multiplier,
  plans,
  setActivePlot,
  setCardOpen,
  width,
}) {
  if (!activeFloorplan && !plans?.length > 0) {
    return <></>;
  }

  let planToRender = plans[0];

  if (activeFloorplan) {
    planToRender = activeFloorplan;
  }

  if (!planToRender) {
    return <></>;
  }

  return (
    <div
      className={className || 'siteplan__pan'}
      style={{ minWidth: width ?? undefined, minHeight: height ?? undefined }}
    >
      <div
        className="siteplan__map"
        style={{
          backgroundImage: `url(${planToRender.image})`,
        }}
      >
        {planToRender.markers.map((plot) => (
          <Marker
            activeFilters={activeFilters}
            adjustX={adjustX}
            adjustY={adjustY}
            key={plot.id}
            marker={plot}
            multiplier={multiplier}
            setActivePlot={setActivePlot}
            setCardOpen={setCardOpen}
            type="plot"
          />
        ))}
      </div>
    </div>
  );
}
